import { StatusGantt } from "@components/index";
import { useStatusGantt } from "../hooks/useStatusGantt";

interface StatusGanttFragmentType {
  event?: Sentinel.Timeline.Event,
  size?: "default" | "large";
}

const StatusGanttFragment: React.FC<React.HTMLAttributes<HTMLDivElement> &
  StatusGanttFragmentType> = ({ event, size }) => {
    const status = event?.status;
    const showLateIcon = !!event?.displayProps?.showLateIcon;
    const data = useStatusGantt(status);

    return (
      <StatusGantt variant={data.variant} showLateIcon={showLateIcon} size={size}>
        {data.text}
      </StatusGantt>
    );
  };

export default StatusGanttFragment;
